import React from 'react';
var Tooltip = function (props) {
    return (React.createElement("div", { className: "Tooltip" },
        React.createElement("span", { className: "text" }, typeof props.text !== 'string' ? props.text() : props.text)));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map